/**
 * @Description: 标签图标分类信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  LabelIconCategoryModel,
  LabelIconCategorySearchModel,
  LabelIconCategoryPageSearchModel,
  LabelIconCategoryAddModel,
  LabelIconCategoryUpdateModel,
  LabelIconCategoryUpdateOrderListModel,
  IdsModel
} from '@/model/product/LabelIconCategoryModel'

const baseUrl = Route.product + '/labelIconCategory'

/**
 * 搜索分页数据
 */
export const pageSearchLabelIconCategory = (param: LabelIconCategoryPageSearchModel) => {
  return https().request<RootObject<PageRespModel<LabelIconCategoryModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchLabelIconCategory = (param: LabelIconCategorySearchModel) => {
  return https().request<RootObject<LabelIconCategoryModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getLabelIconCategory = (id: number) => {
  return https().request<RootObject<LabelIconCategoryModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addLabelIconCategory = (param: LabelIconCategoryAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateLabelIconCategory = (param: LabelIconCategoryUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据排序
 */
export const updateLabelIconCategoryOrder = (param: LabelIconCategoryUpdateOrderListModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update/order'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeLabelIconCategory = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveLabelIconCategory = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
